import Navigation from '../Navigation/Navigation';

export default function AppBar() {
  return (
    <header>
      <Navigation />
    </header>
  );
}